import Logo from "components/Home/Logo/Logo";
import React, { useState } from "react";
import { logo3 } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";

export default function InvoiceModal({
  data,
  hotel,
  landPackage,
  cruise,
  close,
}) {
  const {
    insurance_passenger_details,
    insurance_from_pax,
    hotel_from_pax,
    insurance_to_supplier,
    landpackage_from_pax,
    landpackage_to_supplier,
    cruise_from_pax,
    cruise_to_supplier,
    hotel_to_supplier,
    booking_date,
    sales_agents,
    special_remarks,
    other_remarks,
    invoice_number,
    customer_details,
    passengers,
    created_at,
    valid_canadian_passport,
    canadian_citizenship_or_prCard,
    valid_travel_visa,
    tourist_card,
    insurance_details,
    hotelDetails,
    landPackageDetails,
    cruiseDetails,
    country_name,
    fromAirport,
    toAirport,
    supplier,
    gds_locator,
    mco,
    ref_no_et,
    status,
    departure_date,
    airLine,
    insurance_supplier_name,
    land_package_supplier_name,
    cruise_supplier_name,
    hotel_supplier_name,
  } = data;

  const service =
    hotelDetails || landPackageDetails || cruiseDetails || insurance_details;
  const prefax =
    hotel_from_pax ||
    insurance_from_pax ||
    landpackage_from_pax ||
    cruise_from_pax;
  const preSupplier =
    insurance_to_supplier ||
    hotel_to_supplier ||
    landpackage_to_supplier ||
    cruise_to_supplier;
  const [showSupplier, setShowSupplier] = useState(false);
  const totalPassenger =
    parseOrZero(passengers?.adt) +
    parseOrZero(passengers?.chd) +
    parseOrZero(passengers?.inf);

  const documents = [
    { label: "Valid Passport", value: valid_canadian_passport },
    {
      label: "Canadian Citizenship or PR Card",
      value: canadian_citizenship_or_prCard,
    },
    { label: "Valid Travel Visa", value: valid_travel_visa },
    { label: "Tourist Card", value: tourist_card },
  ];

  const toBoolean = (value) => String(value).toLowerCase() === "true";

  // A helper function to safely parse a value as a float, defaulting to 0 if invalid.
  function parseOrZero(value) {
    if (value == null) return 0;
    const parsed = parseFloat(value);
    return isNaN(parsed) ? 0 : parsed;
  }

  // Calculate financials using the helper function:
  const paxTotal = parseOrZero(prefax?.total);

  const supplierTotal = parseOrZero(preSupplier?.total);
  const paymentReceivedFromSupplier = parseOrZero(
    preSupplier?.payment_received_from_supplier
  );
  const paymentMade = parseOrZero(preSupplier?.paymentMade);
  const refundReceivedFromSupplier = toBoolean(
    preSupplier?.refund_received_from_supplier
  );
  const supplierRefund = parseOrZero(preSupplier?.refund);
  const recallCommissionSupplier = parseOrZero(
    preSupplier?.recall_commission_to_supplier
  );
  const paxRefund = parseOrZero(prefax.refund);
  const cashInhand = parseOrZero(preSupplier?.cash_in_hand);

  const finalPaxTotal = parseOrZero(paxTotal) - parseOrZero(paxRefund);
  const finalSupplierTotal =
    parseOrZero(supplierTotal) - parseOrZero(supplierRefund);

  const cashInhandTotalpassenger = cashInhand * totalPassenger;

  console.log(cashInhand, "pax total");
  console.log(cashInhandTotalpassenger, "cashInhandTotalpassenger");

  // Calculate profit.
  // profit = paxTotal - supplierTotal + supplier's received payment.
  const profit = +(
    finalPaxTotal -
    finalSupplierTotal +
    cashInhandTotalpassenger
  ).toFixed(2);

  // Calculate supplier balance.
  const noRefund = refundReceivedFromSupplier ? 0 : supplierRefund || 0;
  const adjustCommission =
    supplierRefund && paymentReceivedFromSupplier
      ? paymentReceivedFromSupplier
      : 0;
  const recall = recallCommissionSupplier || 0;
  // supplierBalance = supplierTotal - paymentMade - paymentReceivedFromSupplier.

  const supplierBalance = parseFloat(
    (
      paymentMade -
      supplierTotal -
      paymentReceivedFromSupplier +
      noRefund -
      adjustCommission +
      recall
    ).toFixed(2)
  );

  // A reusable component for rendering a label/value row
  const DetailRow = ({ label, value }) => {
    if (!value) return null;
    return (
      <div className="flex justify-between">
        <p className="font-semibold">{label}:</p>
        <span>{value}</span>
      </div>
    );
  };

  const safeNumber = (value) => {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  };

  return (
    <>
      {/* Global print CSS to remove scrollbars and minimize spacing */}
      <style>{`
  @media print {
    /* Hide everything by default */
    body * {
      visibility: hidden;
      font-family: Arial, sans-serif;
    }
    /* Make the invoice content visible */
    #invoice-content, #invoice-content * {
      visibility: visible;
    }
    /* Fix header and footer so they repeat on every page */
    #invoice-header, #invoice-footer {
      position: fixed;
      left: 0;
      right: 0;
    }
    #invoice-header {
      top: 0;
      /* set a height if needed */
      height: 190px;
    }
    #invoice-footer{
      position: absolute;
      bottom: 0px;
    }
    /* Make sure the body has top and bottom margins to avoid overlap */
    #invoice-body {
      margin-top: 150px;  /* slightly more than header height */
      margin-bottom: 60px; /* slightly more than footer height */
    }
    @page {
      margin: 0 !important;
    }
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      overflow: visible !important;
    }
    /* Other print adjustments as before */
    * {
      overflow: visible !important;
      -ms-overflow-style: none !important;
      scrollbar-width: none !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    ::-webkit-scrollbar {
      display: none !important;
    }
    .overflow-x-auto {
      overflow: visible !important;
    }
    .no-print {
      display: none !important;
    }
    .modal, .modal-box {
      margin: 0 !important;
      padding: 0 !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
`}</style>

      <div className="modal modal-open">
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="h-screen w-screen overflow-auto rounded-none bg-white p-0 text-black shadow-xl"
            id="invoice-content"
          >
            {/* Header Section */}
            <div
              id="invoice-header"
              className="bg-gradient-to-r from-black to-black p-10 text-white"
            >
              <div className="flex items-center justify-between">
                <div>
                  <Logo
                    logo1={logo1}
                    logo2={logo2}
                    logo3={logo3}
                    width={{
                      logo1: "w-16",
                      logo2: "w-60 mt-1",
                      logo3: "w-40 mt-1",
                    }}
                  />
                </div>
                <div className="no-print">
                  <h4 className=" text-center text-lg font-bold">
                    {showSupplier
                      ? "INVOICE SUPPLIER VERSION"
                      : "INVOICE PASSENGER VERSION"}
                  </h4>
                  <div className=" flex flex-col items-center justify-center gap-2">
                    <label
                      htmlFor="supplier-toggle"
                      className="flex cursor-pointer items-center gap-2"
                    >
                      <span className="text-lg font-medium">Supplier View</span>
                      <input
                        id="supplier-toggle"
                        type="checkbox"
                        checked={showSupplier}
                        onChange={() => setShowSupplier((prev) => !prev)}
                        className={`toggle toggle-sm ${
                          showSupplier
                            ? "bg-green-500 hover:bg-gray-400"
                            : "bg-gray-400 hover:bg-green-500"
                        }`}
                        aria-label="Toggle supplier view"
                      />
                    </label>
                  </div>
                </div>

                <div className="text-md text-right">
                  <p className="">Invoice No: {invoice_number}</p>
                  <p className="">
                    Invoice Date: {new Date(created_at).toLocaleDateString()}
                  </p>

                  <p className="">Client No: {customer_details.phone_number}</p>
                  <p className="">PNR: {gds_locator}</p>
                  <p className="">TICO REGISTRATION NO.: 12345 (RETAIL)</p>
                  <p className="">
                    TICO REGISTRATION NO.: 12345 (WHOLESALE)
                  </p>
                  {/* Wrap supplier view toggle in no-print */}
                </div>
              </div>
            </div>

            <div id="invoice-body" className="p-10">
              {/* Flight & Passenger Header */}
              <div className="border-b-2 border-blue-200 px-2 py-2">
                <div className="grid grid-cols-5 text-lg">
                  <div className="col-span-1">
                    <p className="text-lg font-semibold">Bill To:</p>
                    {customer_details ? (
                      <div className={`flex flex-col gap-1`}>
                        <div className="flex gap-2">
                          {" "}
                          {customer_details.full_name && (
                            <p className="text-gray-800">
                              {customer_details.full_name},
                            </p>
                          )}
                          {customer_details.city_name && (
                            <p className="uppercase text-gray-800">
                              {customer_details.city_name},
                            </p>
                          )}
                          {customer_details.phone_number && (
                            <p className="text-gray-800">
                              {customer_details.phone_number}
                            </p>
                          )}
                        </div>
                        {customer_details.address && (
                          <p className="text-gray-800">
                            {customer_details.address}
                          </p>
                        )}
                      </div>
                    ) : (
                      <p className="italic text-gray-500">
                        No customer details provided
                      </p>
                    )}
                  </div>

                  <div>
                    <p className="font-semibold">Booking Date</p>
                    <p className="text-lg">{booking_date}</p>
                  </div>
                  {supplier && showSupplier && (
                    <div>
                      <p className={`font-semibold uppercase tracking-wide`}>
                        Supplier
                      </p>
                      <p className={`text-gray-800`}>
                        {insurance_supplier_name ||
                          land_package_supplier_name ||
                          cruise_supplier_name ||
                          hotel_supplier_name}
                      </p>
                    </div>
                  )}
                  <div>
                    {airLine && (
                      <div>
                        <p className={`font-semibold`}>Airline</p>
                        <p className={``}>{airLine?.airline_name}</p>
                      </div>
                    )}
                  </div>
                  <div>
                    <p className="font-semibold">Booking Agent</p>
                    <p className="text-lg">{sales_agents?.name}</p>
                  </div>
                  <div>
                    <p className={`font-semibold uppercase tracking-wide`}>
                      Ticket status
                    </p>
                    <p className={`font-mono`}>{status}</p>
                  </div>
                  {mco && (
                    <div>
                      <p className={`font-semibold uppercase tracking-wide`}>
                        Mco
                      </p>
                      <p className={``}>{mco}</p>
                    </div>
                  )}
                  {ref_no_et && (
                    <div>
                      <p className={`font-semibold uppercase tracking-wide`}>
                        Ref NO
                      </p>
                      <p className={``}>{ref_no_et}</p>
                    </div>
                  )}

                  <div className="col-span-2">
                    <h2 className={`font-bold`}>
                      {fromAirport?.name} &rarr; {toAirport?.name}
                    </h2>
                    <p className="text-md ">{departure_date}</p>
                  </div>
                  {insurance_passenger_details?.length > 0 && (
                    <div className="col-span-2">
                      <p className="text-lg font-semibold">Passenger</p>
                      <div className={`flex flex-wrap gap-1`}>
                        {insurance_passenger_details.map((passenger, index) => (
                          <div key={index} className="text-lg">
                            {passenger.title} {passenger.first_name}{" "}
                            {passenger.last_name}
                            {index !== insurance_passenger_details.length - 1 &&
                              ", "}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Flight Itinerary */}
              <div
                className={`grid ${
                  showSupplier ? "grid-cols-2" : "grid-cols-4"
                } py-5`}
              >
                <div className="col-span-2 bg-yellow-50">
                  <h2 className=" bg-yellow-400 px-2 text-lg font-bold">
                    {hotel
                      ? "Hotel Details"
                      : landPackage
                      ? "Land Package Details"
                      : cruise
                      ? "Cruise Details"
                      : "Insurance Details"}
                  </h2>
                  <div className="p-2">
                    <div className="space-y-1">
                      {hotelDetails || landPackageDetails || cruiseDetails ? (
                        // Render hotel details
                        <>
                          <DetailRow
                            label={
                              hotel
                                ? "Hotel Name"
                                : landPackage
                                ? "Package Name"
                                : cruise
                                ? "Cruise Name"
                                : ""
                            }
                            value={
                              hotel
                                ? service?.hotel_name
                                : landPackage
                                ? service?.package_name
                                : cruise
                                ? service.cruise_name
                                : ""
                            }
                          />

                          <DetailRow label="Country" value={country_name} />
                          <DetailRow
                            label="Start Date"
                            value={service?.start_date}
                          />
                          <DetailRow
                            label="End Date"
                            value={service?.end_date}
                          />
                          <DetailRow
                            label="Operator"
                            value={service?.operator}
                          />
                        </>
                      ) : (
                        // Render insurance details
                        <>
                          <DetailRow
                            label="Insurance Provider"
                            value={service?.insurance_provider}
                          />
                          <DetailRow
                            label="Policy Number"
                            value={service?.policy_number}
                          />
                          <DetailRow
                            label="Effective Date"
                            value={service?.effective_date}
                          />
                          <DetailRow
                            label="Termination Date"
                            value={service?.termination_date}
                          />
                          <DetailRow
                            label="Amount Insured"
                            value={service?.amount_insured}
                          />
                          <DetailRow
                            label="Insurance Plan"
                            value={service?.insurance_plan}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {!showSupplier && (
                  <div className="col-span-2 bg-blue-50">
                    <div className="grid grid-cols-4 bg-gray-400 px-2 text-white">
                      <p></p>
                      <p className="text-right text-lg">Base Fare</p>
                      <p className="text-right text-lg">GST/HST</p>
                      <p className="text-right text-lg">Taxes</p>
                    </div>
                    <div className="p-2 text-lg">
                      <div className="grid grid-cols-4">
                        <p className="font-semibold">
                          {safeNumber(passengers?.adt)} Adult
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.baseFare?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.gstHst?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.taxes?.adt1)}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p className="font-semibold">
                          {safeNumber(passengers?.chd)} Child
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.baseFare?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.gstHst?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.taxes?.chd1)}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p className="font-semibold">
                          {safeNumber(passengers?.inf)} Infant
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.baseFare?.inf1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.gstHst?.inf1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(prefax?.taxes?.inf1)}
                        </p>
                      </div>
                    </div>

                    <div className="p-2">
                      {/* Divider */}
                      <div className="my-2 border-t"></div>
                      {/* Summary Section */}
                      <div className="w-full text-lg">
                        <div className="flex justify-between ">
                          <span className="font-bold">Total Amount:</span>
                          <span className="text-right">${prefax?.total}</span>
                        </div>
                        <div className="flex justify-between ">
                          <span className="font-bold">Amount Paid:</span>
                          <span className="text-right">
                            ${prefax?.amountPaid}
                          </span>
                        </div>
                        {/* {prefax.refund && ( */}
                        <div className="flex justify-between ">
                          <span className="font-bold">Refund:</span>
                          <span className="text-right">
                            $
                            {isNaN(prefax?.refund)
                              ? 0
                              : Number(prefax.refund).toFixed(2)}
                          </span>
                        </div>
                        {/* )} */}
                        {/* {prefax.refund_paid && ( */}
                        <div className="flex justify-between ">
                          <span className="font-bold">Refund Paid:</span>
                          <span className="text-right">
                            ${prefax.refund_paid}
                          </span>
                        </div>
                        {/* )} */}
                        <div className="flex justify-between  font-bold">
                          <span className="font-bold">Balance Due:</span>
                          <span className="text-right">
                            <span
                              className={
                                prefax?.balance > 0
                                  ? "text-red-600"
                                  : "text-green-600"
                              }
                            >
                              ${prefax?.balance}
                            </span>
                          </span>
                        </div>
                        <div className="flex justify-between ">
                          <span className="font-bold">Payment Method:</span>
                          <span className="text-right">
                            <span>{prefax?.transaction_type_name}</span>
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="font-bold">
                            Payment Received From Pax
                          </span>
                          <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                            {prefax?.payment_received_from_pax === "true" ? (
                              <span className="text-sm text-green-500">
                                &#10003;
                              </span>
                            ) : (
                              <span className="text-sm text-red-500">
                                &#10007;
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between font-bold">
                          <span>Final Total</span>
                          <span>${finalPaxTotal}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* Financial Section */}
              {showSupplier && (
                <div className="grid grid-cols-2 gap-2 px-2 py-2">
                  {/* Payment Details from Pax */}
                  <div className="rounded-lg bg-blue-50 p-4">
                    <div className=" grid grid-cols-4 justify-between bg-gray-400 px-2 text-white">
                      <p></p>
                      <p className="text-right">
                        {safeNumber(passengers?.adt)} Adult
                      </p>
                      <p className="text-right">
                        {safeNumber(passengers?.chd)} Child
                      </p>
                      <p className="text-right">
                        {safeNumber(passengers?.inf)} Infant
                      </p>
                    </div>
                    <h3 className=" text-lg font-bold text-blue-800">
                      Payment Details from Pax
                    </h3>
                    <div>
                      <div className="h-full bg-blue-50 pt-1 text-base text-black">
                        <div className="space-y-1">
                          {/* Cost Breakdown */}
                          <div className="grid grid-cols-4">
                            <p>Base Fare:</p>
                            <p className="text-right">
                              {safeNumber(prefax?.baseFare?.adt1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.baseFare?.chd1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.baseFare?.inf1)}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>GST/HST:</p>
                            <p className="text-right">
                              {safeNumber(prefax?.gstHst?.adt1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.gstHst?.chd1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.gstHst?.inf1)}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>Taxes:</p>
                            <p className="text-right">
                              {safeNumber(prefax?.taxes?.adt1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.taxes?.chd1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.taxes?.inf1)}
                            </p>
                          </div>
                          <div className="grid grid-cols-4">
                            <p>Subtotal:</p>
                            <p className="text-right">
                              {safeNumber(prefax?.subTotal?.adt1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.subTotal?.chd1)}
                            </p>
                            <p className="text-right">
                              {safeNumber(prefax?.subTotal?.inf1)}
                            </p>
                          </div>
                          {/* Additional Details */}
                          <div className=" flex justify-between border-t pt-2">
                            <span className="font-bold">Total:</span>
                            <span className="font-bold">
                              ${safeNumber(prefax?.total)}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span>Total Paid:</span>
                            <span>${safeNumber(prefax?.amountPaid)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Balance:</span>
                            <span>${safeNumber(prefax?.balance)}</span>
                          </div>
                          <div className="flex justify-between">
                            <span>Payment Method</span>
                            <p>{prefax?.transaction_type_name || "N/A"}</p>
                          </div>
                          {/* {prefax.refund && ( */}
                          <div className="flex justify-between ">
                            <span className="">Refund:</span>
                            <span className="text-right">
                              $
                              {isNaN(prefax?.refund)
                                ? 0
                                : Number(prefax.refund).toFixed(2)}
                            </span>
                          </div>
                          {/* )} */}
                          {/* {prefax.refund_paid && ( */}
                          <div className="flex justify-between ">
                            <span className="">Refund Paid:</span>
                            <span className="text-right">
                              ${prefax.refund_paid}
                            </span>
                          </div>
                          {/* )} */}
                          <div className="flex justify-between">
                            <span>Payment Received From Pax</span>
                            <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                              {prefax?.payment_received_from_pax === "true" ? (
                                <span className="text-sm text-green-500">
                                  &#10003;
                                </span>
                              ) : (
                                <span className="text-sm text-red-500">
                                  &#10007;
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-between font-bold">
                            <span>Final Total</span>
                            <span>${finalPaxTotal}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Payment Details to Supplier */}
                  <div className="rounded-lg bg-green-50 p-4">
                    <div className=" grid grid-cols-4 justify-between bg-green-400 px-2 text-white">
                      <p></p>
                      <p className="text-right">
                        {safeNumber(passengers?.adt)} Adult
                      </p>
                      <p className="text-right">
                        {safeNumber(passengers?.chd)} Child
                      </p>
                      <p className="text-right">
                        {safeNumber(passengers?.inf)} Infant
                      </p>
                    </div>
                    <h3 className=" text-lg font-bold text-green-800">
                      Payment Details to Supplier
                    </h3>
                    <div className="space-y-1">
                      <div className="grid grid-cols-4">
                        <p>Base Fare:</p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.baseFare?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.baseFare?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.baseFare?.inf1)}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>GST/HST:</p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.gstHst?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.gstHst?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.gstHst?.inf1)}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>Taxes:</p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.taxes?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.taxes?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.taxes?.inf1)}
                        </p>
                      </div>
                      <div className="grid grid-cols-4">
                        <p>Subtotal:</p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.subTotal?.adt1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.subTotal?.chd1)}
                        </p>
                        <p className="text-right">
                          {safeNumber(preSupplier?.subTotal?.inf1)}
                        </p>
                      </div>
                      {/* Additional Details */}
                      <div className=" flex justify-between border-t pt-2">
                        <span className="font-bold">Total Cost:</span>
                        <span className="font-bold">
                          ${safeNumber(preSupplier?.total)}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Payment Method</span>
                        <p>{preSupplier?.transaction_type_name || "N/A"}</p>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Payment Made to Supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>${preSupplier?.paymentMade}</p>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Commission from Supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>${preSupplier?.payment_received_from_supplier}</p>
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Recall commission to supplier</span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>
                            $
                            {isNaN(
                              parseFloat(
                                preSupplier?.recall_commission_to_supplier
                              )
                            )
                              ? 0
                              : parseFloat(
                                  preSupplier?.recall_commission_to_supplier
                                )}
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-between py-0">
                        <span className="">Refund from supplier</span>
                        <span className="text-right">
                          <span>
                            $
                            {isNaN(preSupplier?.refund)
                              ? 0
                              : preSupplier?.refund}
                          </span>
                        </span>
                      </div>
                      <div className="flex justify-between py-0">
                        <span className="">Cash in hand</span>
                        <span className="text-right">
                          <span>
                            $
                            {isNaN(preSupplier?.cash_in_hand)
                              ? 0
                              : preSupplier?.cash_in_hand}
                          </span>
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="">
                          Commission Received from Supplier
                        </span>
                        <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {preSupplier?.commission_from_supplier === "true" ? (
                            <span className="text-sm text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-sm text-red-500">
                              &#10007;
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Refund Received from Supplier</span>
                        <div className="flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {preSupplier?.refund_received_from_supplier ===
                          "true" ? (
                            <span className="text-sm text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-sm text-red-500">
                              &#10007;
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">
                          {" "}
                          Supplier balance due (Comm. + Refund)
                        </span>
                        <div className="mr-2 flex h-4 w-4 items-center justify-center">
                          <p>{supplierBalance}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Profit Calculation */}
                  <div className="col-span-2 rounded-lg bg-yellow-50 px-2 py-2">
                    <div className="flex items-center justify-between">
                      <div>
                        <h4 className="text-lg font-bold">Agency Profit</h4>
                      </div>
                      <div className="text-2xl font-bold text-green-700">
                        ${safeNumber(profit).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="p-2">
                <h2 className=" text-lg font-semibold">
                  Travel Documents Required:
                </h2>
                <div className="grid grid-cols-5 justify-evenly">
                  {documents?.map((doc, index) => {
                    const isTrue = doc.value === true || doc.value === "true";
                    return (
                      <div
                        key={index}
                        className={`${
                          index === 1 ? "col-span-2 justify-center" : ""
                        }  flex items-center`}
                      >
                        {/* Fake checkbox */}
                        <div className="mr-2 flex h-4 w-4 items-center justify-center rounded border border-gray-400">
                          {isTrue ? (
                            <span className="text-lg text-green-500">
                              &#10003;
                            </span>
                          ) : (
                            <span className="text-lg text-red-500">
                              &#10005;
                            </span>
                          )}
                        </div>
                        <span className="text-lg">{doc.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Remarks Section */}
              <div className="border-t px-2 pt-5">
                <h3 className=" text-lg font-bold">Special Remarks:</h3>
                <div className="space-y-1 text-lg">
                  {special_remarks && <p className="">{special_remarks}</p>}
                  {/* {other_remarks && (
                  <p className="">
                    <strong>Other Notes:</strong> {other_remarks}
                  </p>
                )} */}
                </div>
              </div>

              {/* Print Button */}
              <div className="no-print p-6 text-center">
                <button
                  className="btn btn-primary"
                  onClick={() => window.print()}
                >
                  Print Invoice
                </button>
              </div>
            </div>

            {/* Footer */}
            <div id="invoice-footer" className="text-center text-sm">
              <Logo
                logo3={logo3}
                width={{
                  logo3: "w-60  mt-1",
                }}
              />
              <div className="bg-gray-100 p-4">
                <p className="text-black">
                  2883 Derry Rd E, Mississauga, ON L4T 1A6, Canada
                </p>
                <p className="text-black">
                  Contact: support@maharajaflights.com | Tel: 905 678 1200 | Fax:
                  905 678 1201
                </p>
              </div>
            </div>

            {/* Close Button */}
            <button
              className="no-print hover-text-white btn btn-circle btn-sm absolute left-6 top-6 border border-red-500 bg-white text-lg text-red-500 hover:bg-red-500 hover:text-white"
              onClick={close}
            >
              {"<"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
